import React from 'react';
import BootcampCTA from './BootcampCTA';
export default function UpsellBanner() { return <BootcampCTA context="general" />; }
